module.exports = __webpack_public_path__ + "img/powered-by-stripe-light.00b3f30e.svg";